import React from 'react';

const About = () => {
  return (
    <div className="py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <h1 className="text-4xl sm:text-5xl font-heading font-bold tracking-tighter text-primary-main mb-12" data-testid="about-heading">
          About Precision Peptides AU
        </h1>

        <div className="space-y-8 text-text-secondary leading-relaxed">
          <div>
            <h2 className="text-2xl font-heading font-semibold text-primary-main mb-4">Our Mission</h2>
            <p>
              Precision Peptides AU is a research supply company dedicated to providing high-purity peptides 
              for laboratory and scientific research purposes. We serve researchers, laboratories, and academic 
              institutions with precision-tested compounds that meet rigorous quality standards.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-heading font-semibold text-primary-main mb-4">Quality Commitment</h2>
            <p className="mb-4">
              Every product we supply undergoes independent third-party testing by accredited analytical laboratories. 
              We maintain a minimum purity standard of ≥98% and provide complete transparency through readily 
              accessible Certificates of Analysis (COAs).
            </p>
            <p>
              Our commitment to quality extends beyond testing. We maintain proper storage conditions, implement 
              batch tracking systems, and ensure proper handling throughout the supply chain.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-heading font-semibold text-primary-main mb-4">Research Focus</h2>
            <p>
              We position ourselves as a legitimate scientific supplier, not a supplement brand. All our products 
              are intended exclusively for laboratory research purposes and are not designed, marketed, or approved 
              for human consumption or veterinary applications.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-heading font-semibold text-primary-main mb-4">Australian Operations</h2>
            <p>
              Based in Australia, we provide fast domestic shipping to research facilities across the country. 
              Our local presence ensures reliable supply chains, quick delivery times, and compliance with 
              Australian regulatory standards.
            </p>
          </div>

          <div className="bg-background-subtle border border-slate-200 rounded-lg p-8 mt-12">
            <h3 className="font-heading font-semibold text-primary-main mb-4">Contact Research Enquiries</h3>
            <p className="text-sm mb-4">
              For institutional purchasing, bulk orders, or research collaboration enquiries, please contact us 
              through our dedicated research enquiry form.
            </p>
            <a href="/contact" className="text-accent-main hover:text-accent-main/80 font-medium transition-colors">
              Contact Us →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
